// asset imports
import "@/assets/scss/soft-ui-dashboard.scss";

export default {
  install(app: any, options: any): void {
    // configure the app
  },
};
